import axios from "axios";
import { LegacyWebSocketHandler, datasets } from "./RTDNotif";
import { CONF } from "./types/Config";
export { isSocketClosed } from "./RTDNotif";
export class WebSocketHandler extends LegacyWebSocketHandler {
    async subscribeV2(datasetName, subscriberDataSet) {
        const token = CONF.accessToken;
        const orderBy = subscriberDataSet.subscribeParams?.orderBy;
        const orderDirection = subscriberDataSet.subscribeParams?.orderDirection;
        const filters = subscriberDataSet.subscribeParams?.filters;
        try {
            const res = await axios.post(new URL("v2/subscribe", CONF.apiGatewayHost).href, {
                timestamp: new Date().getTime(),
                datasets: [{ name: datasetName, orderBy, orderDirection, filters }],
                websocketSubscriptionId: this.subscriptionId
            }, {
                headers: { Authorization: `Bearer ${token}`, ...this.httpHeaders }
            });
            subscriberDataSet.isInProgress = false;
            subscriberDataSet.isError = false;
            const { data } = res;
            return data;
        }
        catch (e) {
            // eslint-disable-next-line no-console
            console.error(`[RTDWC-V2] Error while subscription | ${e} | timestamp=${new Date()}, UTC=${new Date().toUTCString()}`);
            subscriberDataSet.isInProgress = false;
            subscriberDataSet.isError = true;
            datasets.get(datasetName).subscriptionCallback(e);
            throw e;
        }
    }
    unsubscribeV2(datasetName) {
        return axios.post(new URL("v1/unsubscribe", CONF.apiGatewayHost).href, {
            timestamp: new Date().getTime(),
            datasets: [datasetName],
            websocketSubscriptionId: this.subscriptionId
        }, {
            headers: { Authorization: `Bearer ${CONF.accessToken}`, ...this.httpHeaders }
        });
    }
}
export const notif = new WebSocketHandler();
